<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Hospicash Settings' }}</h2>
      <p>Company letterhead, contacts &amp; images printed on the partner welcome / subscription letter.</p>
    </div>
    <p-button label="Add Config" icon="pi pi-plus" (onClick)="openAdd()" />
  </div>

  <div class="card">
    <p-table [value]="visible()" [loading]="loading()" dataKey="id" [rows]="10"
      [paginator]="visible().length > 10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm"
      [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 90px">Logo</th>
          <th>Company</th>
          <th>Contacts</th>
          <th style="width: 110px">Active</th>
          <th class="ta-r" style="width: 120px">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td>
            @if (imgSrc(r.letterheadImage)) { <img class="lh-thumb" [src]="imgSrc(r.letterheadImage)" alt="" /> }
            @else { <span class="dash">—</span> }
          </td>
          <td>
            <div class="issuer-text">
              <span class="issuer-name">{{ r.companyName }}</span>
              @if (r.website) { <small class="issuer-sub">{{ r.website }}</small> }
            </div>
          </td>
          <td>
            <div class="issuer-text">
              @if (r.email) { <small class="issuer-sub">{{ r.email }}</small> }
              @if (r.customerCare) { <small class="issuer-sub">Care: {{ r.customerCare }}</small> }
              @if (!r.email && !r.customerCare) { <span class="dash">—</span> }
            </div>
          </td>
          <td>
            <span class="active-toggle" (click)="toggleActive(r)" pTooltip="Click to toggle">
              <p-tag [value]="r.isActive ? 'Active' : 'Inactive'" [severity]="r.isActive ? 'success' : 'secondary'" />
            </span>
          </td>
          <td class="ta-r actions">
            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary" pTooltip="Edit" (onClick)="openEdit(r)" />
            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" pTooltip="Delete" (onClick)="remove(r)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <div class="state"><i class="pi pi-envelope"></i><p>No config yet. Add one to get started.</p></div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [closable]="true" [dismissableMask]="false"
  [header]="editing() ? 'Edit Hospicash Config' : 'New Hospicash Config'" styleClass="menu-dialog"
  [style]="{ width: '720px' }" [breakpoints]="{ '740px': '95vw' }">
  <form [formGroup]="form" class="menu-form">
    <div class="field">
      <label>Company Name <span class="req">*</span></label>
      <input pInputText type="text" formControlName="companyName" placeholder="AROGYA KAVACH SOLUTIONS PRIVATE LIMITED" autocomplete="off">
      @if (form.get('companyName')?.touched && form.get('companyName')?.invalid) { <small class="err">Company name is required</small> }
    </div>

    <div class="field">
      <label>Company Short Name <small class="hint-muted">(used in the letter body / signature)</small></label>
      <input pInputText type="text" formControlName="companyShortName" placeholder="Arogya Kavach Solutions Pvt. Ltd." autocomplete="off">
    </div>

    <div class="field">
      <label>Address</label>
      <textarea pTextarea formControlName="addressLine" rows="2" placeholder="Flat No. 2GF, ..., Nagpur, Maharashtra, India"></textarea>
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Customer Care</label>
        <input pInputText type="text" formControlName="customerCare" placeholder="80 688 68 688" autocomplete="off">
      </div>
      <div class="field">
        <label>Email</label>
        <input pInputText type="text" formControlName="email" placeholder="info@arogyakavach.in" autocomplete="off">
      </div>
    </div>

    <div class="field">
      <label>Website / Site URL</label>
      <input pInputText type="text" formControlName="website" placeholder="https://www.arogyakavach.in/" autocomplete="off">
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Hospicash Claim No.</label>
        <input pInputText type="text" formControlName="hospicashClaimNumber" placeholder="1800 209 1016 / 1800 103 8889" autocomplete="off">
      </div>
      <div class="field">
        <label>Doctor-on-Call No.</label>
        <input pInputText type="text" formControlName="docAssistanceNumber" placeholder="1800 209 8090" autocomplete="off">
      </div>
    </div>

    <p class="section-note"><i class="pi pi-image"></i> Upload JPG/PNG images — they save immediately and print on the letter.</p>

    <div class="field">
      <label>Letterhead / Logo</label>
      <app-doc-upload formControlName="letterheadImage" module="HospicashLetterhead" />
      @if (letterheadPreview()) { <div class="logo-preview"><p-image [src]="letterheadPreview()" alt="Letterhead" [preview]="true" width="140" /></div> }
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Signature</label>
        <app-doc-upload formControlName="signatureImage" module="HospicashSignature" />
        @if (signaturePreview()) { <div class="logo-preview"><p-image [src]="signaturePreview()" alt="Signature" [preview]="true" width="120" /></div> }
      </div>
      <div class="field">
        <label>Stamp / Seal</label>
        <app-doc-upload formControlName="stampImage" module="HospicashStamp" />
        @if (stampPreview()) { <div class="logo-preview"><p-image [src]="stampPreview()" alt="Stamp" [preview]="true" width="120" /></div> }
      </div>
    </div>

    <label class="switch-row">
      <p-toggleSwitch formControlName="isActive" />
      <span>Active</span>
    </label>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
      <p-button label="Save" (onClick)="save()" [loading]="saving()" />
    </div>
  </form>
</p-dialog>
